import { StyleSheet } from 'react-native'
import theme from '../../../theme'
import { LoginTheme } from '../../../themeConstants'

const styles = StyleSheet.create({
    containerLogin: {
        flex: 1,
        width: '100%',
        justifyContent: 'space-between',
        padding: 15,
    },
    version: {
        fontSize: 14,
        fontWeight: 'normal',
        textAlign: 'center',
        color: theme.colors.textSecondary,
        marginBottom: 12,
    },
    image: {
        width: LoginTheme.clientLogoWidth,
        height: LoginTheme.clientLogoHeight,
        alignSelf: 'center',
        marginBottom: LoginTheme.clientLogoMarginBottom,
    },
    button: {
        flexDirection: 'column',
        width: '100%',
        paddingTop: 28,
        paddingBottom: 16,
    },
    buttonText: {
        fontSize: 14,
        fontWeight: 'bold',
        color: LoginTheme.loginTextcolor,
        width: '100%',
        textAlign: 'right',
    },
    buttonContainer: {
        padding: 5,
        bottom: 0,
        width: '100%',
    },
    mainButton: {
        width: '100%',
        height: 40,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 5,
    },
    mainButtonText: {
        fontSize: 15,
        color: LoginTheme.mainButtonTextColor,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    borderButton: {
        borderWidth: 2,
        borderColor: LoginTheme.backButtonTextColor,
        paddingVertical: 8,
        paddingHorizontal: 50,
        borderRadius: 10,
    },
    borderButtonText: {
        color: LoginTheme.backButtonTextColor,
        fontWeight: 'bold',
        fontSize: 15,
        textAlign: 'center',
    },
    start: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 4,
        textAlign: 'left',
        color: theme.colors.textSecondary,
    },
    containerUser: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 12,
        paddingVertical: 8,
        borderWidth: 1.0,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
    },
    avatar: {
        width: 44,
        height: 44,
        borderRadius: 22,
    },
    username: {
        fontSize: 15,
        fontWeight: 'bold',
        textAlign: 'left',
        color: theme.colors.textPrimary,
    },
    email: {
        fontSize: 14,
        fontWeight: 'normal',
        textAlign: 'left',
        color: theme.colors.textPrimary,
    },
    lastConnection: {
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'left',
        color: theme.colors.textSecondary,
    },
    floatingButtonText: {
        fontSize: 15,
        fontWeight: 'bold',
        textAlign: 'center',
        color: theme.colors.colorPrimary,
    },
    marginHorizontal: {
        marginHorizontal: 12,
    },
    paddingHorizontal: {
        paddingHorizontal: 12,
    },
    spacer: {
        height: 4,
    },
    spacer1: {
        height: 12,
    },
    //MODAL
    containerFlex: {
        flex: 1,
    },
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: 0,
    },
})

export default styles
